import { createContext, useContext } from 'react'

import type { CartItem } from '../../types'

/** A basket line and the branch it sits at. */
export type CartLineAtBranch = Pick<CartItem, 'id' | 'branchId'>

export interface LocationChangeContextValue {
  /**
   * Cart line id → the branch id it was at when the engineer last changed
   * location. The cart flags a line still at that branch once it's far away.
   */
  lineBranchesAtMove: Record<string, string>
  /** Called by the Change Location drawer after a confirmed move. */
  markLocationChanged: (lines: CartLineAtBranch[]) => void
}

// Lives here rather than beside the provider so the provider's file exports
// only a component (react-refresh/only-export-components).
export const LocationChangeContext = createContext<LocationChangeContextValue>({
  lineBranchesAtMove: {},
  markLocationChanged: () => {},
})

/**
 * Read which basket lines were kept at their branch through the engineer's
 * last location change, and record a new change. See `LocationChangeProvider`
 * for how long that lasts.
 */
export function useLocationChange(): LocationChangeContextValue {
  return useContext(LocationChangeContext)
}
